import { Campaign } from '@lidea/shared/util/types';

import { privateClient } from './api-client';

export const campaignsApi = {
  getAll: () =>
    privateClient
      .get('campaigns/')
      .json<Campaign[]>()
      .then((campaigns) =>
        [...campaigns].sort((a, b) => (a.year ?? 0) - (b.year ?? 0))
      ),
  getOne: (id: number) =>
    privateClient.get(`campaigns/${id}/`).json<Campaign>(),
};

export default campaignsApi;
